import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const CenteredBox = styled(Box)(({theme})=>({
    height : "100%",
    display:"flex",
    justifyContent:"center",
    alignItems:"center"
}));
